import { ApiProperty } from "@nestjs/swagger";

export class QnoCountReqModelDto {
    @ApiProperty()
    chapter: number;

    @ApiProperty()
    subAbilityId?: number;

    @ApiProperty()
    marks: number
}